import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { TruckForm } from "@/features/dashboard/caminhoes/components/TruckForm";

export const Route = createFileRoute("/_private/dashboard/_trucks/caminhoes/cadastrar/modal")({
  component: () => (
    <BaseEditCreateModal title="Criar novo Caminhão" from="/dashboard/caminhoes/cadastrar">
      <TruckForm />
    </BaseEditCreateModal>
  )
});
